import { memo, useMemo } from 'react';

import { PERMISSION_SOURCE } from '../../constants/copy';
import PermissionSourceTag from '../shared/PermissionSourceTag';
import RoleSourceTags from '../shared/RoleSourceTags';
import UserTypeBadge from '../shared/UserTypeBadge';

/**
 * Source tags of a studio row: "via <Role>" per role (more than three collapse into "+N" with a
 * tooltip), Direct when direct grants exist, or the Admin / Owner type tag.
 *
 * @param {object} props
 * @param {{ type: 'role'|'direct'|'admin'|'owner', label: string }[]} props.sources
 */
const StudioSourceTags = ({ sources }) => {
  const roles = useMemo(() => sources.filter(({ type }) => type === 'role').map(({ label }) => label), [sources]);
  const hasDirect = sources.some(({ type }) => type === 'direct');
  const privileged = sources.filter(({ type }) => type === 'admin' || type === 'owner');

  return (
    <>
      <RoleSourceTags roles={roles} />
      {hasDirect ? <PermissionSourceTag source={PERMISSION_SOURCE.DIRECT} /> : null}
      {privileged.map(({ type }) => (
        <UserTypeBadge key={type} userType={type} />
      ))}
    </>
  );
};

export default memo(StudioSourceTags);
